import { Loading, PermissionDenied } from '@/components';
import type { FC, PropsWithChildren } from 'react';

import {
  useGlobalTagPermission,
  useLocalTagPermission,
} from '../_hooks/permission';
import type { ResourceGuardProps } from '../_types/authentication';

export const TagResourceGuard: FC<PropsWithChildren<ResourceGuardProps>> = ({
  onlyEdit,
  showDenied,
  children,
}) => {
  const globalTagPermission = useGlobalTagPermission(onlyEdit);
  const localTagPermission = useLocalTagPermission(onlyEdit);

  if (globalTagPermission.isPending || localTagPermission.isPending) {
    return <Loading />;
  }

  return globalTagPermission.data || localTagPermission.data ? (
    <>{children}</>
  ) : showDenied ? (
    <PermissionDenied />
  ) : null;
};
